export default "__VITE_ASSET__BKj7pSxc__"